{
  "deselectedItem": "{item} seçilmedi.",
  "select": "Seç",
  "selectedAll": "Tüm ögeler seçildi.",
  "selectedCount": "{count, plural, =0 {Hiçbir öge seçilmedi} one {# öge seçildi} other {# öge seçildi}}.",
  "selectedItem": "{item} seçildi."
}
